import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Tabs from '../components/erp/tabs/Tab';
import Buyer from '../components/erp/buyer/Buyer';
import BuyerFilter from '../components/erp/buyerFilter/BuyerFilter';
import BuyWithToday from '../components/erp/buyWithToday/BuyWithToday';
import BuyBill from '../components/erp/buyBill/BuyBill';
import BuyWithInStock from '../components/erp/buyWithInStock/BuyWithInStock';
import { apiUrl } from '../components/apiUrl/ApiUrl';

export default function PurchaseManager() {
  // 把「未簽核查詢」移除
  const tabArray = ['請採購簽核', '簽核查詢', '列印請採購', '請採購單', '請採購預定入庫表'];
  const [activeTab, setActiveTab] = useState(0);

  const [dataBuyer, setBuyerData] = useState(null);
  const [dataBuyerFilter, setBuyerFilterData] = useState(null);
  const [dataBuyToday, setBuyTodayData] = useState(null);
  const [dataBuyInStock, setBuyInStockData] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem('jwtData');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        switch (activeTab) {
          case 0: { // 請採購簽核
            const { data } = await axios.get(`${apiUrl}/Buyer/GetMains?page=1`);
            setBuyerData(data);
            break;
          }
          case 1: { // 簽核查詢
            const { data } = await axios.get(`${apiUrl}/Buyer/GetMainsByFilter?page=1`);
            setBuyerFilterData(data);
            break;
          }
          case 2: { // 列印請採購
            const { data } = await axios.get(`${apiUrl}/Buyer/GetMainsWithToday`);
            setBuyTodayData(data);
            break;
          }
          case 3: { // 請採購單
            // 原本 case 4 的畫面不需要預撈資料（維持原本行為）
            break;
          }
          case 4: { // 請採購預定入庫表
            const { data } = await axios.get(`${apiUrl}/Buyer/GetMainsWithInStock`);
            setBuyInStockData(data);
            break;
          }
          default:
            break;
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [activeTab]);

  const renderTabContent = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return <Buyer data={dataBuyer} />;
      case 1:
        return <BuyerFilter data={dataBuyerFilter} />;
      case 2:
        return <BuyWithToday data={dataBuyToday} />;
      case 3:
        return <BuyBill />;
      case 4:
        return <BuyWithInStock data={dataBuyInStock} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <Tabs tabsNames={tabArray} activeTab={activeTab} setActiveTab={setActiveTab} />
      {renderTabContent(activeTab)}
    </div>
  );
}
